import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-375c7601"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "index-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"0.5rem"} }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-title" }, "客户过程管理")
], -1))

import CustomerStageStatus from './componects/CustomerStageStatus.vue'
import FollowInTimeRate from './componects/FollowInTimeRate.vue'
import CustomerKeyData from './componects/CustomerKeyData.vue'
import TransactCustomerDistribution from './componects/TransactCustomerDistribution.vue'
import { PropType } from 'vue'
import CustomerAlarmTrend from './componects/CustomerAlarmTrend.vue'
import AlarmPieCombine from './componects/AlarmPieCombine.vue'
import CustomerVisitCompletionStatus from './componects/CustomerVisitCompletionStatus.vue'


const __default__ = { name: 'Tab2' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  appId: {
    type: String as PropType<'cos_fbu' | 'cos_lbu'>,
    default: 'cos_fbu'
  },
  formState: {
    type: Object as PropType<Object>
  }
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(CustomerKeyData, {
      formState: props.formState
    }, null, 8, ["formState"]),
    _createVNode(_component_a_row, { gutter: 8 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(CustomerStageStatus, {
              height: "300px",
              appId: "cos_fbu",
              formState: props.formState
            }, null, 8, ["formState"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(FollowInTimeRate, {
              height: "300px",
              appId: "cos_fbu",
              customerRegionEmployeeNoList: props.formState.customerRegionEmployeeNoList
            }, null, 8, ["customerRegionEmployeeNoList"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(AlarmPieCombine, {
              height: "300px",
              appId: "cos_fbu",
              formState: props.formState
            }, null, 8, ["formState"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { gutter: 8 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(TransactCustomerDistribution, {
              height: "300px",
              appId: "cos_fbu",
              formState: props.formState
            }, null, 8, ["formState"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(CustomerVisitCompletionStatus, {
              height: "300px",
              appId: "cos_fbu",
              formState: props.formState
            }, null, 8, ["formState"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(CustomerAlarmTrend, {
              height: "300px",
              appId: "cos_fbu",
              customerRegionEmployeeNoList: props.formState.customerRegionEmployeeNoList
            }, null, 8, ["customerRegionEmployeeNoList"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})